import React, { createContext, useEffect, useState } from "react";
import { AxiosHelper } from "../../helpers/axios";
import jwt from "jsonwebtoken";
import { useUnidades } from "../../hooks/test/useUnidades";
import Swal from "sweetalert2";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const {
    getRegistroEventos
  } = useUnidades();
  const [negocioSeleccionado, SetnegocioSeleccionado] = useState(null);

  const [user, setUser] = useState(
    localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
  );
  const [statusUsuarioActual, setStatusUsuarioActual] = useState(
    localStorage.getItem("statusUsuarioActual") ? JSON.parse(localStorage.getItem("statusUsuarioActual")) : {}
  );

  const [stateJornada, setStateJornada] = useState(
    localStorage.getItem("stateJornada") ? JSON.parse(localStorage.getItem("stateJornada")) : {}
  );

  const [ stateTurno, setStateTurno ] = useState(
    localStorage.getItem("stateTurno") ? JSON.parse(localStorage.getItem("stateTurno")) :
    {
    comida: false,
    descanso: false,
    servicio_medico: false,
    sanitario: false,
    permiso: false,
    finalizarJornada: false,
  });

  const [eventosCarga, setEventosCarga] = useState(
    localStorage.getItem("eventosCarga") ? JSON.parse(localStorage.getItem("eventosCarga")) :
    []
    );

  useEffect(() => {
    
    
    let [ok] = verifyJWT();
    if (!ok) return;

    let userCedis = localStorage.getItem("cedis")
      ? JSON.parse(localStorage.getItem("cedis"))
      : [];
    let usuario = user;

    usuario.cedis = userCedis;
    setUser(usuario);
    if(user){
      if(user.rol === "Monitorista"){
        loadInfo();
      }
    }
    
  }, []);

  const cleanNavegador = async() => {
     
    const mensaje = await Swal.fire({
      title: "¡Upss!",
      text: "¡Tu sesión ha cerrado por que se ha finalizado tu jornada o se cerro sesión en otro equipo!",
      icon: "warning",
      showConfirmButton: false,
      timer: 7000
    });

    mensaje.then(expulsar());

    function expulsar() {
      
      clearSesion();
      console.log("ejecutando: cleanNavegador");
      window.location.href = "/login";
      localStorage.setItem("lastPath", "");
      
    }

  }

  const loadInfo = async() => {
      const eventosJornada = await getRegistroEventos(user.id);

      if (eventosJornada && eventosJornada.ok){
          setEventosCarga(eventosJornada.registros);
          if(eventosJornada.estatusUsuario.includes("Inicio")){
            setStateJornada(eventosJornada.estatusUsuario.slice(7));
            localStorage.setItem("stateJornada", JSON.stringify(eventosJornada.estatusUsuario.slice(7)));
          }else{
            setStateJornada(eventosJornada.estatusUsuario);
            console.log("actualizando stateJornada...");
            localStorage.setItem("stateJornada", JSON.stringify(eventosJornada.estatusUsuario));
          }
          

          if(eventosJornada.estatusUsuario === "Inicio Comida"){
            setStateTurno({...stateTurno, comida: true});
          }else
          if(eventosJornada.estatusUsuario === "Inicio Descanso"){
            setStateTurno({...stateTurno, descanso: true});
          }
          if(eventosJornada.estatusUsuario === "Inicio Servicio Medico"){
            setStateTurno({...stateTurno, servicio_medico: true});
          }else
          if(eventosJornada.estatusUsuario === "Inicio Llamada Telefonica"){
            setStateTurno({...stateTurno, llamada_telefonica: true});
          }else
          if(eventosJornada.estatusUsuario === "Inicio Sanitario"){
            setStateTurno({...stateTurno, sanitario: true});
          }else
          if(eventosJornada.estatusUsuario === "Inicio Tienda"){
            setStateTurno({...stateTurno, tienda: true});
          }else
          if(eventosJornada.estatusUsuario === "Inicio Permiso"){
            setStateTurno({...stateTurno, permiso: true});
          }
          
          // localStorage.setItem("stateJornada", JSON.stringify(eventosJornada.ultimoEvento));
          if (eventosJornada.estatusUsuario === "Inactivo"){
            cleanNavegador();
          }
      }
  }
  /**
   * Servicio para iniciar sesión
   * @param {text} username
   * @param {text} password
   */
  const login = async (username, password) => {
    //
    let resp = await AxiosHelper(
      `login`,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({
        userName: username,
        password: password,
      }),
      (resp) => {
        return onLogin(resp);
      },
      (message) => {
        return {
          ok: false,
          msg: message,
        };
      }
    );
    return resp;
  };
  const onLogin = (respuesta) => {
    const { usuario } = respuesta.data;
    let menus = crearMenu(usuario.menu);

    let userLoged = {
      id: usuario.id,
      numEmpleado: usuario.users_num_empleado,
      name: usuario.name,
      roles_id: usuario.roles_id,
      rol: usuario.rol,
      email: usuario.email,
      permisosMenu: menus,
      token: usuario.token,
      cedis: usuario.cedis,
      estatus: usuario.tipo_registro_id,
      negocio_id: usuario.negocio_id,
      cedis_id: usuario.cedis_id,
      negocio: usuario.negocio,
      flujo_id: usuario.flujo_id,
    };
    setUser(userLoged);
    setStateJornada("");
    localStorage.setItem("stateJornada", JSON.stringify(""));
    localStorage.setItem("user", JSON.stringify(userLoged));
    localStorage.setItem("x-token", JSON.stringify(userLoged.token));
    return { ok: true, user: userLoged };
  };
  const crearMenu = (menus) => {
    //
    let permisosMenu = {};
    menus.map((x) => {
      switch (x.title) {
        case "PROGRAMAR SALIDA":
          return (permisosMenu.programarSalida = true);
        case "EN RUTA":
          return (permisosMenu.enRuta = true);
        case "BITACORA":
          return (permisosMenu.bitacora = true);
        case "GENERACION DE CODIGOS":
          return (permisosMenu.generacionCodigos = true);
        case "TABLERO_MONITOREO":
          return (permisosMenu.tablero = true);
        case "AUTOS":
          return (permisosMenu.autos = true);
        case "MOTOS":
          return (permisosMenu.motos = true);
        case "CAMIONES":
          return (permisosMenu.camiones = true);
        case "ADMINISTRACION DE VIAJES":
          return(permisosMenu.administracionViajes = true)
        case "ADMINISTRACION UNIDADES":
            return (permisosMenu.administracionUidades = true);
        case "BOLETINADOS":
          return (permisosMenu.boletinados = true);
        case "GESTION DE REPORTES":
          return (permisosMenu.gestionDeReportes = true);
        // case "TABLERO DE CONTINGENCIA":
        //   return (permisosMenu.contingencia = true);
        case "ADMINISTRACIÓN":
          return (permisosMenu.admin = true);
        case "TABLERO DE ADMINISTRACION":
          return (permisosMenu.tableroAdministracion = true);
        case "PROGRAMAR RUTA":
          return (permisosMenu.programarRuta = true);
        case "EVENTOS DE SEGURIDAD":
          return (permisosMenu.eventosDeSeguridad = true);
        case "REPORTE EVENTOS SEGURIDAD":
          return (permisosMenu.reporteEventosDeSeguridad  = true);
        default:
          break;
      }
      return "";
    });
    return permisosMenu;
  };
  const clearSesion = () => {
    localStorage.removeItem("user");
    localStorage.clear();
    setUser({});
  };
  useEffect(() => {
    verifyJWT();

    let userCedis = localStorage.getItem("cedis")
      ? JSON.parse(localStorage.getItem("cedis"))
      : [];
    setUser({ ...user, cedis: userCedis });
  }, []);
  const verifyJWT = (token = "") => {
    try {
      if (!token && localStorage.getItem("x-token")) {
        token = localStorage.getItem("x-token");
        token = token.substring(1);
        token = token.substring(0, token.length - 1);
      }
      if (!token) return [false];
      const { userId, rolId, cedis } = jwt.verify(
        token,
        process.env.REACT_APP_JWT_KEY
      );

      return [true, userId, rolId, cedis];
    } catch (error) {
      clearSesion();
      window.location.href = "/login";
      return [false, null];
    }
  };
  const renewToken = async (token = "") => {
    let usuarioAUX = JSON.parse(localStorage.getItem("user"));
    usuarioAUX.token = token;
    localStorage.removeItem("user");
    localStorage.setItem("user", JSON.stringify(usuarioAUX));

    return setUser({ ...user, usuarioAUX });
  };
  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        clearSesion,
        verifyJWT,
        setUser,
        renewToken,
        stateJornada,
        setStateJornada,
        stateTurno,
        setStateTurno,
        statusUsuarioActual,
        setStatusUsuarioActual,
        eventosCarga, 
        setEventosCarga,
        negocioSeleccionado,
        SetnegocioSeleccionado,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
